import logger from '../utils/logger';
import React, { useContext, useState, useEffect } from 'react';
import '../style/GenerateClaim.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { GlobalStateContext } from "../utils/GlobalStateContext";
import { numberToLetter, formatToLocalDate, capitalize, getUserId, dateOfBirth } from '../utils/utils';
import { InputMask } from '@react-input/mask';
import PDFModalClaimForm from '../utils/PDFModalClaimForm';
import PatientInsuranceModal from './PatientInsuranceForm';
import { ToastContainer, toast } from 'react-toastify';

const UniqueBillingClaimForm = () => {
  const location = useLocation();
  const { order_id } = location.state || {};
  const { currentPatient, currentUser } = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL;
  const userId = getUserId(currentUser);
  // logger.log("user id: ", userId);
  const [showModal, setShowModal] = useState(false);
  const [showInsuranceModal, setShowInsuranceModal] = useState(false);

  const [formData, setFormData] = useState({
    patient: {
      name: '',
      dob: '',
      sex: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
    },
    // insured: {
    //   name: '',
    //   address: '',
    //   city: '',
    //   state: '',
    //   zip: '',
    //   phone: '',
    //   policyNumber: '',
    //   relationship: '',
    // },
    // prev_insured: {
    //   name: '',
    //   address: '',
    //   city: '',
    //   state: '',
    //   zip: '',
    //   phone: '',
    //   policyNumber: '',
    //   relationship: '',
    // },
    claim: {
      insuranceType: '',
      illnessDate: '',
      otherDate: '',
      unableToWorkFrom: '',
      unableToWorkTo: '',
      hospitalizationFrom: '',
      hospitalizationTo: '',
      referringProvider: '',
      referringProviderNPI: '',
      prior_authorization: '',
    },
    diagnoses: Array(12).fill(''), // Initialize as array of empty strings
    services: [{
      dateFrom: '',
      dateTo: '',
      pos: '',
      cpt: '',
      modifiers: '',
      diagnosisPointers: '',
      charges: '',
      units: '',
      emergency: false,
      familyPlan: false,
    }],
    financial: {
      totalCharge: '',
      amountPaid: '',
      balanceDue: '',
    },
    signatures: {
      patientSignature: 'Signature on File',
      insuredSignature: 'Signature on File',
      physicianSignature: 'Signature on File',
    },
  });

  const [plans, setPlans] = useState([{}]);
  const [standingOrders, setStandingOrders] = useState([]);

  const cptCodeCharges = {
    "G0463": 0.00,
    "99202": 100.00,
    "99203": 110.00,
    "99204": 160.00,
    "99205": 244.99,
    "99212": 50.00,
    "99213": 90.88,
    "99214": 120.00,
    "99215": 165.00
  };

  const handleChange = (section, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        [field]: value,
      },
    }));
  };

  const handleDiagnosisChange = (index, value) => {
    const newDiagnoses = [...formData.diagnoses];
    newDiagnoses[index] = value; // Store string directly
    setFormData((prevData) => ({
      ...prevData,
      diagnoses: newDiagnoses,
    }));
  };

  const handleServiceChange = (index, field, value) => {
    const newServices = [...formData.services];
    const updatedService = {
      ...newServices[index],
      [field]: value
    };

    if (field === 'cpt') {
      const charge = cptCodeCharges[value] ?? 0.00;
      updatedService.charges = parseFloat(charge.toFixed(2));
    }

    newServices[index] = updatedService;

    setFormData((prevData) => ({
      ...prevData,
      services: newServices
    }));
  };

  const handleAddService = () => {
    if (formData.services.length < 6) {
      setFormData(prev => ({
        ...prev,
        services: [...prev.services, {
          dateFrom: '',
          dateTo: '',
          pos: '',
          cpt: '',
          modifiers: '',
          diagnosisPointers: '',
          charges: '',
          units: '',
          emergency: false,
          familyPlan: false
        }]
      }));
    }
  };

  const handleRemoveService = () => {
    setFormData(prev => {
      if (prev.services.length > 1) {
        return {
          ...prev,
          services: prev.services.slice(0, -1)
        };
      }
      return prev;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // logger.log(JSON.stringify(formData));

    const cleanedDiagnoses = formData.diagnoses.filter(code => code.trim() !== ''); // Filter out empty strings
    // logger.log('cleaned diag: ', cleanedDiagnoses);

    const submissionData = {
      ...formData,
      patient: {
        ...formData.patient,
        dob: formatToLocalDate(formData.patient.dob)
      },
      diagnoses: cleanedDiagnoses,
      user: currentUser.biller_id,
      clinicNoteId: clinic_note_id
    };

    // logger.log('submission data: ', submissionData);
    try {
      const response = await fetch(`${BASE_URL}/billing/addClaim?ris_patients_id=${currentPatient?.patient[0]?.ris_patients_id}&user=${user}&type=${currentUser.type}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ submissionData, user, type: currentUser.type }),
      });
      if (response.ok) {
        const data = await response.json();
        logger.log('Claim created successfully');
        setFormData({
          patient: { name: '', dob: '', sex: '', address: '', city: '', state: '', zip: '', phone: '' },
          // insured: { name: '', address: '', city: '', state: '', zip: '', phone: '', policyNumber: '', relationship: '' },
          // prev_insured: { name: '', address: '', city: '', state: '', zip: '', phone: '', policyNumber: '', relationship: '' },
          claim: {
            insuranceType: '',
            illnessDate: '',
            otherDate: '',
            unableToWorkFrom: '',
            unableToWorkTo: '',
            hospitalizationFrom: '',
            hospitalizationTo: '',
            referringProvider: '',
            referringProviderNPI: '',
          },
          diagnoses: Array(12).fill(''), // Reset to array of empty strings
          services: [{
            dateFrom: '',
            dateTo: '',
            pos: '',
            cpt: '',
            modifiers: '',
            diagnosisPointers: '',
            charges: '',
            units: '',
            emergency: false,
            familyPlan: false,
          }],
          financial: { totalCharge: '', amountPaid: '', balanceDue: '' },
          signatures: {
            patientSignature: 'Signature on File',
            insuredSignature: 'Signature on File',
            physicianSignature: 'Signature on File',
          },
        });
        navigate('/Billing');
      } else {
        const data = await response.json();
        if (data?.errors.length) {
          data.errors.forEach(err => {
            toast.error(err.message, { //`Service ${err.index + 1} is missing: ${err.missingFields.join(', ')}`
              autoClose: 8000 // Specify pop up time in milliseconds
            });
          });
        }
        // logger.log(data)
        logger.error('Error creating claim');
      }
    } catch (error) {
      logger.error('Fetch error:', error);
    }
  };

  useEffect(() => {
    const getDemographicInfo = async () => {
      try {
        const response = await fetch(`${BASE_URL}/billing/displayClaimDemographics?ris_patients_id=${currentPatient?.patient[0]?.ris_patients_id}&type=${currentUser.type}&user=${userId}`);
        if (response.ok) {
          const data = await response.json();
          // logger.log(data)
          // logger.log(JSON.stringify(data));
          setFormData(prev => ({
            ...prev,
            patient: data
          }));
        } else {
          logger.log("Error getting patient info");
        }
      } catch (error) {
        logger.error(error);
      }
    };
    const getInsuranceInfo = async () => {
      try {
        const response = await fetch(`${BASE_URL}/billing/getPatientPlans?ris_patients_id=${currentPatient?.patient[0]?.ris_patients_id}`);
        if (response.ok) {
          const data = await response.json();
          // logger.log(JSON.stringify(data));
          setPlans(data);
          // logger.log(data)
        } else {
          logger.log("Error getting patient info");
        }
      } catch (error) {
        logger.error(error);
      }
    };
    const getStandingOrders = async () => {
      try {
        const response = await fetch(`${BASE_URL}/billing/getStandingOrders?order_id=${order_id}`);
        if (response.ok) {
          const data = await response.json();
          // logger.log(JSON.stringify(data));
          setStandingOrders(data);
          // logger.log(data)
        } else {
          logger.log("Error getting standing info");
        }
      } catch (error) {
        logger.error(error);
      }
    };
    getDemographicInfo();
    getInsuranceInfo();
  }, []);

  useEffect(() => {
    if (formData.financial?.totalCharge && formData.financial?.amountPaid) {
      setFormData(prev => ({
        ...prev,
        financial: {
          ...prev.financial,
          balanceDue: (
            Number(prev.financial.totalCharge) -
            Number(prev.financial.amountPaid)
          ).toFixed(2)
        }
      }));
    }
  }, [formData.financial?.totalCharge, formData.financial?.amountPaid]);

  useEffect(() => {
    const totalCharges = formData.services?.reduce((sum, service) => {
      return sum + Number(service.charges || 0);
    }, 0);

    setFormData(prev => ({
      ...prev,
      financial: {
        ...prev.financial,
        totalCharge: totalCharges.toFixed(2)
      }
    }));
  }, [formData.services]);
  
  // const handleDelete = async () => {
  //   if (!form.id) {
  //     alert("No patient record to delete.");
  //     return;
  //   }

  //   try {
  //     const res = await fetch(`${BASE_URL}/patient-insurance/${form.id}`, {
  //       method: "DELETE",
  //     });

  //     if (!res.ok) throw new Error("Failed to delete insurance");
  //     logger.log(`Deleted insurance ID: ${form.id}`);
  //     onClose();
  //   } catch (err) {
  //     logger.error(err);
  //   }
  // };

  return (
    <div>
      <div className="claim-form-container">
      <div className='forms-row'>
      <div className={showModal ? "note-claim-gen-form-container" : "unique-claim-gen-form-container"}>
        <h2>Billing Claim Form</h2>
        <form onSubmit={handleSubmit}>
          <div className="unique-claim-gen-section">
            <div className='claim-header-row'>
            <h3 className='no-margin'>Patient Information</h3>
            <button type="button" className='PrimaryButton' onClick={() => {setShowModal(true);}}>Standing Orders</button>
            
            </div>
            <div className="unique-claim-gen-section">
              <div className="patient-grid">
                <div className="form-field">
                  <label className="label-style">Patient Name</label>
                  <input
                    className="input-style"
                    type="text"
                    value={formData.patient.name}
                    onChange={(e) => handleChange('patient', 'name', e.target.value)}
                    required
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Date of Birth</label>
                  <input
                    className="input-style"
                    type="date"
                    value={formatToLocalDate(formData.patient.dob)}
                    onChange={(e) => handleChange('patient', 'dob', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Sex</label>
                  <select
                    className="input-style"
                    value={formData.patient.sex}
                    onChange={(e) => handleChange('patient', 'sex', e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div className="form-field">
                  <label className="label-style">Address</label>
                  <input
                    className="input-style"
                    type="text"
                    value={formData.patient.address}
                    onChange={(e) => handleChange('patient', 'address', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">City</label>
                  <input
                    className="input-style"
                    type="text"
                    value={formData.patient.city}
                    onChange={(e) => handleChange('patient', 'city', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">State</label>
                  <InputMask
                    className="input-style"
                    mask="XX"
                    placeholder = "Enter state 'MO'"
                    replacement={{X: /[a-zA-Z]/}}
                    type="text"
                    value={formData.patient.state}
                    onChange={(e) => handleChange('patient', 'state', e.target.value.toUpperCase())}
                    />
                </div>
                <div className="form-field">
                  <label className="label-style">ZIP Code</label>
                  <InputMask
                    mask = 'XXXXX'
                    replacement={{X: /\d/}}
                    className="input-style"
                    type="text"
                    value={formData.patient.zip}
                    onChange={(e) => handleChange('patient', 'zip', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Phone</label>
                  <InputMask
                    mask="(XXX) XXX-XXXX"
                    replacement={{ X: /\d/ }}
                    className="input-style"
                    type="text"
                    value={formData.patient.phone}
                    onChange={(e) => handleChange('patient', 'phone', e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='unique-claim-gen-section'>
            <div className='claim-header-row'>
              <h3 className='no-margin'>Mapped Insurance Information</h3>
              <button type="button" className='PrimaryButton' onClick={() => {setShowInsuranceModal(true);}}>Map Patient Insurance</button>
            </div>
            <div className="unique-claim-gen-form-group"></div>
            
        {plans.length > 0 ? plans.map((plan, index) => (
          // <div> for delete button
        <div className="unique-claim-gen-form-group2" key={index}>
          
          <h4>Insurance Type</h4>
          <h4>{plan.insurance_type}</h4>
          <h4>Plan Name: </h4>
          <h4>{plan.plan_name}</h4>
          <label>Insured Name: </label>
          <span>{plan.insured_name}</span>
          <label>Plan Type: </label>
          <span>{plan.plan_type}</span>
          <label>Insured Relationship: </label>
          <span>{plan.insured_relationship}</span>
          <label>Effective Date: </label>
          <span>{dateOfBirth(plan.effective_date)}</span>
          <label>Member ID: </label>
          <span>{plan.member_id}</span>
          <label>Termination Date: </label>
          <span>{dateOfBirth(plan.termination_date)}</span>
          
          <label>Group Number: </label>
          <span>{plan.group_number}</span>


          

          <label>City: </label>
          <span>{plan.city}</span>

          <label>Address One: </label>
          <span>{plan.address_one}</span>

          <label>State: </label>
          <span>{plan.state}</span>

          <label>Address Two: </label>
          <span>{plan.address_two}</span>

          

          

          <label>Zip Code: </label>
          <span>{plan.zip}</span>

          <label>Phone Number: </label>
          <span>{plan.phone}</span>

          <label>Fax Number: </label>
          <span>{plan.fax}</span>
          <label>Patient Co-Pay: </label>
          <span>{plan.co_pay}</span>
          <label>Notes: </label>
          <span>{plan.notes}</span>
          
          
          {/* </div> delete button
          <button 
            type="button" 
            // onClick={handleDelete} 
            className="delete-btn"
          >
            Delete
          </button> */}
          </div>

      )) : 
      <div className="unique-claim-gen-form-group2"> 
        <h4>No Mapped Insurance</h4>
      </div>}
          </div>
          <div className="unique-claim-gen-section">
            <h3>Claim Details</h3>
            <div className="claim-details-grid">
              <div className="form-field">
                <label className="label-style">Type of Insurance</label>
                <select
                  className="input-style"
                  value={formData.claim.insuranceType}
                  onChange={(e) => handleChange('claim', 'insuranceType', e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Self-Pay">Self-Pay</option>
                  <option value="Group Health Plan">Group Health Plan</option>
                  <option value="Medicare">Medicare</option>
                  <option value="Medicaid">Medicaid</option>
                  <option value="TRICARE">TRICARE</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-field">
                <label className="label-style">Date of Current Illness/Injury/Pregnancy</label>
                <input
                  className="input-style"
                  type="date"
                  value={formData.claim.illnessDate}
                  onChange={(e) => handleChange('claim', 'illnessDate', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Other Date</label>
                <input
                  className="input-style"
                  type="date"
                  value={formData.claim.otherDate}
                  onChange={(e) => handleChange('claim', 'otherDate', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Unable to Work From</label>
                <input
                  className="input-style"
                  type="date"
                  value={formData.claim.unableToWorkFrom}
                  onChange={(e) => handleChange('claim', 'unableToWorkFrom', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Unable to Work To</label>
                <input
                  className="input-style"
                  type="date"
                  value={formData.claim.unableToWorkTo}
                  onChange={(e) => handleChange('claim', 'unableToWorkTo', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Hospitalization From</label>
                <input
                  className="input-style"
                  type="date"
                  value={formData.claim.hospitalizationFrom}
                  onChange={(e) => handleChange('claim', 'hospitalizationFrom', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Hospitalization To</label>
                <input
                  className="input-style"
                  type="date"
                  value={formData.claim.hospitalizationTo}
                  onChange={(e) => handleChange('claim', 'hospitalizationTo', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Referring Provider</label>
                <input
                  className="input-style"
                  type="text"
                  value={formData.claim.referringProvider}
                  onChange={(e) => handleChange('claim', 'referringProvider', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Referring Provider NPI</label>
                <input
                  className="input-style"
                  type="text"
                  value={formData.claim.referringProviderNPI}
                  onChange={(e) => handleChange('claim', 'referringProviderNPI', e.target.value)}
                />
              </div>

              <div className="form-field">
                <label className="label-style">Prior Authorization</label>
                <input
                  className="input-style"
                  type="text"
                  value={formData.claim.prior_authorization}
                  onChange={(e) => handleChange('claim', 'prior_authorization', e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Billing Diagnosis- ICD Codes */}
          <div className="unique-claim-gen-section">
            <h3>Diagnoses (up to 12)</h3>
            <div className="unique-claim-gen-form-group2">
              {formData.diagnoses.map((code, index) => (
                <div key={index} className="form-field">
                  <label className="label-style">Diagnosis {numberToLetter(index + 1)}</label>
                  <input
                    className="input-style"
                    type="text"
                    value={code}
                    onChange={(e) => handleDiagnosisChange(index, e.target.value)}
                    placeholder="ICD Code"
                  />
                </div>
              ))}
            </div>
          </div>
        {/* Billing services */}
        <div className="unique-claim-gen-section">
          <h3>Services (up to 6)</h3>
          {formData.services.map((service, index) => (
            <div key={index} className="unique-claim-gen-service-line">
              <h4>Service {index + 1}</h4>
              <div className="service-grid">
                <div className="form-field">
                  <label className="label-style">Date From</label>
                  <input
                    className="input-style"
                    type="date"
                    value={service.dateFrom}
                    onChange={(e) => handleServiceChange(index, 'dateFrom', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Date To</label>
                  <input
                    className="input-style"
                    type="date"
                    value={service.dateTo}
                    onChange={(e) => handleServiceChange(index, 'dateTo', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Place of Service</label>
                  <input
                    className="input-style"
                    type="text"
                    value={service.pos}
                    onChange={(e) => handleServiceChange(index, 'pos', e.target.value)}
                    placeholder="2-digit code"
                  />
                </div>
                {/* <div className="form-field">
                  <label className="label-style">CPT Code</label>
                  <select
                    name="cpt"
                    value={service.cpt}
                    onChange={(e) => handleServiceChange(index, 'cpt', e.target.value)}
                    className="socialHistoryTextArea"
                  >
                    <option value="">Select a CPT Code</option>
                    <option value="G0463">G0463 – Face to face collection of history for a chronic condition</option>
                    <option value="99202">99202 – 15+ minutes on straightforward medical decision, new patient</option>
                    <option value="99203">99203 – 30+ minutes on low level medical decision, new patient</option>
                    <option value="99204">99204 – 45+ minutes on moderate level medical decision, new patient</option>
                    <option value="99205">99205 – 60+ minutes on high medical decision, new patient</option>
                    <option value="99212">99212 – 10+ minutes on straightforward medical decision, established patient</option>
                    <option value="99213">99213 – 20+ minutes on low level medical decision, established patient</option>
                    <option value="99214">99214 – 30+ minutes on moderate level medical decision, established patient</option>
                    <option value="99215">99215 – 40+ minutes on high medical decision, established patient</option>
                  </select>
                </div> */}
                <div className="form-field">
                  <label className="label-style">CPT Code</label>
                  <input
                    list={`cpt-options-${index}`} // Unique ID per service line
                    name="cpt"
                    className="input-style"
                    value={service.cpt}
                    onChange={(e) => handleServiceChange(index, 'cpt', e.target.value)}
                    placeholder="Enter or select CPT code"
                  />
                  <datalist id={`cpt-options-${index}`}>
                    <option value="G0463">G0463 – Face to face collection of history for a chronic condition</option>
                    <option value="99202">99202 – 15+ minutes on straightforward medical decision, new patient</option>
                    <option value="99203">99203 – 30+ minutes on low level medical decision, new patient</option>
                    <option value="99204">99204 – 45+ minutes on moderate level medical decision, new patient</option>
                    <option value="99205">99205 – 60+ minutes on high medical decision, new patient</option>
                    <option value="99212">99212 – 10+ minutes on straightforward medical decision, established patient</option>
                    <option value="99213">99213 – 20+ minutes on low level medical decision, established patient</option>
                    <option value="99214">99214 – 30+ minutes on moderate level medical decision, established patient</option>
                    <option value="99215">99215 – 40+ minutes on high medical decision, established patient</option>
                  </datalist>
                </div>

                <div className="form-field">
                  <label className="label-style">Modifiers</label>
                  <input
                    type="text"
                    className="input-style"
                    value={service.modifiers}
                    onChange={(e) => handleServiceChange(index, 'modifiers', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Diagnosis Pointers</label>
                  <input
                    className="input-style"
                    type="text"
                    value={service.diagnosisPointers}
                    onChange={(e) => handleServiceChange(index, 'diagnosisPointers', e.target.value)}
                    placeholder="A-L"
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Charges</label>
                  <input
                    className="input-style"
                    type="number"
                    step="0.01"
                    value={service.charges}
                    onChange={(e) => handleServiceChange(index, 'charges', e.target.value)}
                    min="0"
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Units</label>
                  <input
                    className="input-style"
                    type="number"
                    value={service.units}
                    onChange={(e) => handleServiceChange(index, 'units', e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Emergency</label>
                  <input
                    className="input-style"
                    type="checkbox"
                    checked={service.emergency}
                    onChange={(e) => handleServiceChange(index, 'emergency', e.target.checked)}
                  />
                </div>
                <div className="form-field">
                  <label className="label-style">Family Plan</label>
                  <input
                    className="input-style"
                    type="checkbox"
                    checked={service.familyPlan}
                    onChange={(e) => handleServiceChange(index, 'familyPlan', e.target.checked)}
                  />
                </div>
                </div>
              </div>
              ))}
          </div>
          <div className="button-row">
            <button
              className='PrimaryButton'
              onClick={handleAddService}
              disabled={formData.services.length >= 6}
            >
              + Add Service
            </button>
            <button
              className='SecondaryButton'
              onClick={handleRemoveService}
              disabled={formData.services.length <= 1}
            >
              − Remove Service
            </button>
          </div>
          <div className="unique-claim-gen-section">
            <h3>Financial Information</h3>
            <div className="unique-claim-gen-form-group">
              <label className="label-style">Total Charge</label>
              <input
                className="input-style"
                type="number"
                step="0.01"
                value={formData.financial.totalCharge}
                onChange={(e) => handleChange('financial', 'totalCharge', e.target.value)}
                min="0"
              />
            </div>
            <div className="unique-claim-gen-form-group">
              <label className="label-style">Amount Paid</label>
              <input
                className="input-style"
                type="number"
                value={formData.financial.amountPaid}
                onChange={(e) => handleChange('financial', 'amountPaid', e.target.value)}
              />
            </div>
            <div className="unique-claim-gen-form-group">
              <label className="label-style">Balance Due</label>
              <input
                className="input-style"
                type="number"
                value={formData.financial.balanceDue}
                onChange={(e) => handleChange('financial', 'balanceDue', e.target.value)}
              />
            </div>
          </div>

          <div className="unique-claim-gen-section">
            <h3>Signatures</h3>
            <p>Patient Signature: {formData.signatures.patientSignature}</p>
            <p>Insured Signature: {formData.signatures.insuredSignature}</p>
            <p>Physician Signature: {formData.signatures.physicianSignature}</p>
          </div>

          <button type="submit" className='PrimaryButton'>Submit Claim</button>
        </form>
      </div>

    <div className={`${showModal ? 'pdf-claim-gen-form-container modal-open' : ''}`}>
      {showModal && (
        <div>
          <PDFModalClaimForm
            clinic_note_id={clinic_note_id}
            id={currentPatient.patient[0].ris_patients_id}
            onClose={() => setShowModal(false)}
          />
        </div>
      )}
      {showInsuranceModal && (
        <div>
          <PatientInsuranceModal 
            isOpen={showInsuranceModal} 
            onClose={() => setShowInsuranceModal(false)} 
          />
        </div>
      )}
      <ToastContainer />
    </div>
      </div>
    </div>
  </div>
  );
};

export default UniqueBillingClaimForm;

// import React, { useContext, useState, useEffect } from 'react';
// import '../style/GenerateClaim.css';
// import { useNavigate } from 'react-router-dom';
// import UserDetails from './customComponents/tracker';
// import { GlobalStateContext } from '../utils/GlobalStateContext';
// import {numberToLetter} from '../../src/utils/utils';
// import {InputMask} from '@react-input/mask';

// const UniqueBillingClaimForm = () => {
//   const { currentPatient } = useContext(GlobalStateContext);
//   const navigate = useNavigate();
//   const BASE_URL = process.env.REACT_APP_API_URL;


//   const [formData, setFormData] = useState({
//     patient: {
//         name: '',
//         dob: '',
//         sex: '',
//         address: '',
//         city: '',
//         state: '',
//         zip: '',
//         phone: '',
//     },
//     insured: {
//         name: '',
//         address: '',
//         city: '',
//         state: '',
//         zip: '',
//         phone: '',
//         policyNumber: '',
//         relationship: '',
//     },
//     prev_insured: {
//         name: '',
//         address: '',
//         city: '',
//         state: '',
//         zip: '',
//         phone: '',
//         policyNumber: '',
//         relationship: '',
//     },
//     claim: {
//         insuranceType: '',
//         illnessDate: '',
//         otherDate: '',
//         unableToWorkFrom: '',
//         unableToWorkTo: '',
//         hospitalizationFrom: '',
//         hospitalizationTo: '',
//         referringProvider: '',
//         referringProviderNPI: '',
//     },
//     diagnoses: Array(12).fill().map(() => ({
//         diagnosis_code: '',
//         // position: '',
//     })),
//     // services: Array(6).fill().map(() => ({
//     //     dateFrom: '',
//     //     dateTo: '',
//     //     pos: '',
//     //     cpt: '',
//     //     modifiers: '',
//     //     diagnosisPointers: '',
//     //     charges: '',
//     //     units: '',
//     //     emergency: false,
//     //     familyPlan: false,
//     // })),
//     services: [createEmptyService()],
//     financial: {
//       totalCharge: '',
//       amountPaid: '',
//       balanceDue: '',
//     },
//     signatures: {
//       patientSignature: 'Signature on File',
//       insuredSignature: 'Signature on File',
//       physicianSignature: 'Signature on File',
//     },
//   });

//   const handleChange = (section, field, value) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [section]: {
//         ...prevData[section],
//         [field]: value,
//       },
//     }));
//   };

//   const handleDiagnosisChange = (index, value) => {
//     const newDiagnoses = [...formData.diagnoses];
//     newDiagnoses[index] = value;
//     setFormData((prevData) => ({
//         ...prevData,
//         diagnoses: newDiagnoses,
//     }));
//     };

//   const handleServiceChange = (index, field, value) => {
//     const newServices = [...formData.services];
//     newServices[index] = {
//       ...newServices[index],
//       [field]: value,
//     };
//     setFormData((prevData) => ({
//       ...prevData,
//       services: newServices,
//     }));
//   };

//   const handleAddService = () => {
//   if (formData.services.length < 6) {
//     setFormData(prev => ({
//       ...prev,
//       services: [...prev.services, createEmptyService()]
//     }));
//   }
// };

// function createEmptyService() {
//   return {
//     dateFrom: '',
//     dateTo: '',
//     pos: '',
//     cpt: '',
//     modifiers: '',
//     diagnosisPointers: '',
//     charges: '',
//     units: '',
//     emergency: false,
//     familyPlan: false
//   };
// }

// const handleRemoveService = () => {
//   setFormData(prev => {
//     if (prev.services.length > 1) {
//       return {
//         ...prev,
//         services: prev.services.slice(0, -1)
//       };
//     }
//     return prev; // Prevent removing last item
//   });
// };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // logger.log(formData);
//     logger.log(JSON.stringify(formData))
//     try {
//       // ws
//       logger.log(currentPatient.ris_patients_id, 'testing here')
//       const response = await fetch(`${BASE_URL}/billing/addClaim?ris_patients_id=${currentPatient.ris_patients_id}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       if (response.ok) {
//         const data = await response.json();
//         logger.log('Claim created successfully');
//         //
//         setFormData({
//           patient: { name: '', dob: '', sex: '', address: '', city: '', state: '', zip: '', phone: '' },
//           insured: { name: '', address: '', city: '', state: '', zip: '', phone: '', policyNumber: '', relationship: '' },
//           prev_insured: { name: '', address: '', city: '', state: '', zip: '', phone: '', policyNumber: '', relationship: '' },
//           claim: {
//             insuranceType: '',
//             illnessDate: '',
//             otherDate: '',
//             unableToWorkFrom: '',
//             unableToWorkTo: '',
//             hospitalizationFrom: '',
//             hospitalizationTo: '',
//             referringProvider: '',
//             referringProviderNPI: '',
//           },
//           diagnoses: Array(12).fill().map(() => ({
//             diagnosis_code: '',
          
//           })),
//           // services: Array(6).fill().map(() => ({
//           //   dateFrom: '',
//           //   dateTo: '',
//           //   pos: '',
//           //   cpt: '',
//           //   modifiers: '',
//           //   diagnosisPointers: '',
//           //   charges: '',
//           //   units: '',
//           //   emergency: false,
//           //   familyPlan: false,
//           // })),
//           services: [createEmptyService()],
//           financial: { totalCharge: '', amountPaid: '', balanceDue: '' },
//           signatures: {
//             patientSignature: 'Signature on File',
//             insuredSignature: 'Signature on File',
//             physicianSignature: 'Signature on File',
//           },
//         });
//       //
//       navigate('/Billing'); 
//       } else {
//         logger.error('Error creating claim');
//       }
//     } catch (error) {
//       logger.error('Fetch error:', error);
//     }
//   };

//   useEffect(() => {
//     if (formData.financial?.totalCharge && formData.financial?.amountPaid) {
//     //     const balanceDue = (Number(formData.financial?.totalCharge) - Number(formData.financial?.amountPaid)).toFixed(2)
//     //     setFormData({...formData, financial: {...formData.financial, 
//     //                                           balanceDue}})
//     setFormData(prev => ({
//     ...prev,
//     financial: {
//       ...prev.financial,
//       balanceDue: (
//         Number(prev.financial.totalCharge) -
//         Number(prev.financial.amountPaid)
//       ).toFixed(2)
//     }
//   }));
//     }
//   }, [formData.financial?.totalCharge, formData.financial?.amountPaid])

//   useEffect(() => {
//     const totalCharges = formData.services?.reduce((sum, service) => {
//       return sum + Number(service.charges || 0);
//     }, 0);

//     setFormData(prev => ({
//       ...prev,
//       financial: {
//         ...prev.financial,
//         totalCharge: totalCharges.toFixed(2)
//       }
//     }));
//   }, [formData.services]);

//   return (
//     <div className="unique-claim-gen-form-container">
//       <h2>Billing Claim Form</h2>
//       <form onSubmit={handleSubmit}>
//         <div>
//             <UserDetails/> 
//         </div>
//         <div className="unique-claim-gen-section">
//           <h3>Patient Information</h3>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Patient Name</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.patient.name}
//               onChange={(e) => handleChange('patient', 'name', e.target.value)}
//               required
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Date of Birth</label>
//             <input
//               className="input-style"
//               type="date"
//               value={formData.patient.dob}
//               onChange={(e) => handleChange('patient', 'dob', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Sex</label>
//             <select
//               className="input-style"
//               value={formData.patient.sex}
//               onChange={(e) => handleChange('patient', 'sex', e.target.value)}
//             >
//               <option value="">Select</option>
//               <option value="M">Male</option>
//               <option value="F">Female</option>
//               <option value="U">Unknown</option>
//             </select>
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Address</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.patient.address}
//               onChange={(e) => handleChange('patient', 'address', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">City</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.patient.city}
//               onChange={(e) => handleChange('patient', 'city', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">State</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.patient.state}
//               onChange={(e) => handleChange('patient', 'state', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">ZIP Code</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.patient.zip}
//               onChange={(e) => handleChange('patient', 'zip', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Phone</label>
//             <InputMask 
//               mask="(XXX) XXX-XXXX" 
//               replacement={{ X: /\d/ }}
//               className="input-style"
//               type="text"
//               value={formData.patient.phone}
//               onChange={(e) => handleChange('patient', 'phone', e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="unique-claim-gen-section">
//           <h3>Insured Information</h3>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Insured Name</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.insured.name}
//               onChange={(e) => handleChange('insured', 'name', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Policy/Group Number</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.insured.policyNumber}
//               onChange={(e) => handleChange('insured', 'policyNumber', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Relationship to Insured</label>
//             <select
//               className="input-style"
//               value={formData.insured.relationship}
//               onChange={(e) => handleChange('insured', 'relationship', e.target.value)}
//             >
//               <option value="">Select</option>
//               <option value="Self">Self</option>
//               <option value="Spouse">Spouse</option>
//               <option value="Child">Child</option>
//               <option value="Other">Other</option>
//             </select>
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Address</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.insured.address}
//               onChange={(e) => handleChange('insured', 'address', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">City</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.insured.city}
//               onChange={(e) => handleChange('insured', 'city', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">State</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.insured.state}
//               onChange={(e) => handleChange('insured', 'state', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">ZIP Code</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.insured.zip}
//               onChange={(e) => handleChange('insured', 'zip', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Phone</label>
//             <InputMask
//               mask="(XXX) XXX-XXXX" 
//               replacement={{ X: /\d/ }}
//               className="input-style"
//               type="text"
//               value={formData.insured.phone}
//               onChange={(e) => handleChange('insured', 'phone', e.target.value)}
//             />
//           </div>
//         </div>
//         <div className="unique-claim-gen-section">
//           <h3>Previous Insured Information</h3>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Insured Name</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.prev_insured.name}
//               onChange={(e) => handleChange('prev_insured', 'name', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Policy/Group Number</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.prev_insured.policyNumber}
//               onChange={(e) => handleChange('prev_insured', 'policyNumber', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Relationship to Insured</label>
//             <select
//               className="input-style"
//               value={formData.prev_insured.relationship}
//               onChange={(e) => handleChange('prev_insured', 'relationship', e.target.value)}
//             >
//               <option value="">Select</option>
//               <option value="Self">Self</option>
//               <option value="Spouse">Spouse</option>
//               <option value="Child">Child</option>
//               <option value="Other">Other</option>
//             </select>
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Address</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.prev_insured.address}
//               onChange={(e) => handleChange('prev_insured', 'address', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">City</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.prev_insured.city}
//               onChange={(e) => handleChange('prev_insured', 'city', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">State</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.prev_insured.state}
//               onChange={(e) => handleChange('prev_insured', 'state', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">ZIP Code</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.prev_insured.zip}
//               onChange={(e) => handleChange('prev_insured', 'zip', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Phone</label>
//             <InputMask
//               mask="(XXX) XXX-XXXX" 
//               replacement={{ X: /\d/ }}
//               className="input-style"
//               type="text"
//               value={formData.prev_insured.phone}
//               onChange={(e) => handleChange('prev_insured', 'phone', e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="unique-claim-gen-section">
//           <h3>Claim Details</h3>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Type of Insurance</label>
//             <select
//               className="input-style"
//               value={formData.claim.insuranceType}
//               onChange={(e) => handleChange('claim', 'insuranceType', e.target.value)}
//             >
//               <option value="">Select</option>
//               <option value="Medicare">Medicare</option>
//               <option value="Medicaid">Medicaid</option>
//               <option value="TRICARE">TRICARE</option>
//               <option value="CHAMPVA">CHAMPVA</option>
//               <option value="Group Health Plan">Group Health Plan</option>
//               <option value="FECA">FECA</option>
//               <option value="Black Lung">Black Lung</option>
//               <option value="Other">Other</option>
//             </select>
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Date of Current Illness/Injury/Pregnancy</label>
//             <input
//               className="input-style"
//               type="date"
//               value={formData.claim.illnessDate}
//               onChange={(e) => handleChange('claim', 'illnessDate', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Other Date</label>
//             <input
//               className="input-style"
//               type="date"
//               value={formData.claim.otherDate}
//               onChange={(e) => handleChange('claim', 'otherDate', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Unable to Work From</label>
//             <input
//               className="input-style"
//               type="date"
//               value={formData.claim.unableToWorkFrom}
//               onChange={(e) => handleChange('claim', 'unableToWorkFrom', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Unable to Work To</label>
//             <input
//               className="input-style"
//               type="date"
//               value={formData.claim.unableToWorkTo}
//               onChange={(e) => handleChange('claim', 'unableToWorkTo', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Hospitalization From</label>
//             <input
//               className="input-style"
//               type="date"
//               value={formData.claim.hospitalizationFrom}
//               onChange={(e) => handleChange('claim', 'hospitalizationFrom', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Hospitalization To</label>
//             <input
//               className="input-style"
//               type="date"
//               value={formData.claim.hospitalizationTo}
//               onChange={(e) => handleChange('claim', 'hospitalizationTo', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Referring Provider</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.claim.referringProvider}
//               onChange={(e) => handleChange('claim', 'referringProvider', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Referring Provider NPI</label>
//             <input
//               className="input-style"
//               type="text"
//               value={formData.claim.referringProviderNPI}
//               onChange={(e) => handleChange('claim', 'referringProviderNPI', e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="unique-claim-gen-section">
//           <h3>Diagnoses (up to 12)</h3>
//           {formData.diagnoses.map((diagnosis, index) => (
//             <div key={index} className="unique-claim-gen-form-group">
//               <label className="label-style">Diagnosis {numberToLetter(index + 1)}</label>
//               <input
//                 className="input-style"
//                 type="text"
//                 value={formData.diagnosis} // diagnoses ?
//                 onChange={(e) => handleDiagnosisChange(index, e.target.value)}
//                 placeholder="ICD Code"
//               />
//             </div>
//           ))}
//         </div>

//         <div className="unique-claim-gen-section">
//           <h3>Services (up to 6)</h3>
//           {formData.services.map((service, index) => (
//             <div key={index} className="unique-claim-gen-service-line">
//               <h4>Service {index + 1}</h4>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Date From</label>
//                 <input
//                 className="input-style"
//                   type="date"
//                   value={service.dateFrom}
//                   onChange={(e) => handleServiceChange(index, 'dateFrom', e.target.value)}
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Date To</label>
//                 <input
//                 className="input-style"
//                   type="date"
//                   value={service.dateTo}
//                   onChange={(e) => handleServiceChange(index, 'dateTo', e.target.value)}
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Place of Service</label>
//                 <input
//                 className="input-style"
//                   type="text"
//                   value={service.pos}
//                   onChange={(e) => handleServiceChange(index, 'pos', e.target.value)}
//                   placeholder="2-digit code"
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">CPT/HCPCS Code</label>
//                 <input
//                 className="input-style"
//                   type="text"
//                   value={service.cpt}
//                   onChange={(e) => handleServiceChange(index, 'cpt', e.target.value)}
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Modifiers</label>
//                 <input
//                   type="text"
//                   className="input-style"
//                   value={service.modifiers}
//                   onChange={(e) => handleServiceChange(index, 'modifiers', e.target.value)}
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Diagnosis Pointers</label>
//                 <input
//                   className="input-style"
//                   type="text"
//                   value={service.diagnosisPointers}
//                   onChange={(e) => handleServiceChange(index, 'diagnosisPointers', e.target.value)}
//                   placeholder="A-L"
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Charges</label>
//                 <input
//                   className="input-style"
//                   type="number"
//                   value={service.charges}
//                   onChange={(e) => handleServiceChange(index, 'charges', e.target.value)}
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Units</label>
//                 <input
//                   className="input-style"
//                   type="number"
//                   value={service.units}
//                   onChange={(e) => handleServiceChange(index, 'units', e.target.value)}
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Emergency</label>
//                 <input
//                   className="input-style"
//                   type="checkbox"
//                   checked={service.emergency}
//                   onChange={(e) => handleServiceChange(index, 'emergency', e.target.checked)}
//                 />
//               </div>
//               <div className="unique-claim-gen-form-group">
//                 <label className="label-style">Family Plan</label>
//                 <input
//                   className="input-style"
//                   type="checkbox"
//                   checked={service.familyPlan}
//                   onChange={(e) => handleServiceChange(index, 'familyPlan', e.target.checked)}
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="button-row">
//           <button
//             className='ris-bigger-blue-button'
//             onClick={handleAddService}
//             disabled={formData.services.length >= 6}
//           >
//             + Add Service
//           </button>
//           <button
//             className='ris-bigger-blue-button'
//             onClick={handleRemoveService}
//             disabled={formData.services.length <= 1}
//           >
//             − Remove Service
//           </button>
//         </div>
//         <div className="unique-claim-gen-section">
//           <h3>Financial Information</h3>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Total Charge</label>
//             <input
//               className="input-style"
//               type="number"
//               value={formData.financial.totalCharge}
//               onChange={(e) => handleChange('financial', 'totalCharge', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Amount Paid</label>
//             <input
//               className="input-style"
//               type="number"
//               value={formData.financial.amountPaid}
//               onChange={(e) => handleChange('financial', 'amountPaid', e.target.value)}
//             />
//           </div>
//           <div className="unique-claim-gen-form-group">
//             <label className="label-style">Balance Due</label>
//             <input
//               className="input-style"
//               type="number"
//               value={formData.financial.balanceDue}
//               onChange={(e) => handleChange('financial', 'balanceDue', e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="unique-claim-gen-section">
//           <h3>Signatures</h3>
//           <p>Patient Signature: {formData.signatures.patientSignature}</p>
//           <p>Insured Signature: {formData.signatures.insuredSignature}</p>
//           <p>Physician Signature: {formData.signatures.physicianSignature}</p>
//         </div>

//         <button type="submit" className='ris-bigger-blue-button'>Submit Claim</button>
//       </form>
//     </div>
//   );
// };

// export default UniqueBillingClaimForm;